import { useOrg } from "@/lib/states/session/hooks";
import { trpc } from "@/lib/trpc/client";

export function useOrgEntitlements() {
  const org = useOrg();

  return trpc.billing.entitlements.useQuery(undefined, {
    enabled: Boolean(org?.id),
  });
}
